import {
  Avatar, Flex, Td, Tr,
} from "@chakra-ui/react"
import Icon from "components/elements/Icon"
import React from "react"
import { EmailReportRecipient } from "sharedTypes"
import { useLocation } from "react-router-dom"
import { eventPath } from "utilities/routes"
import Link from "components/elements/Link"
import { getColorByInvitationStatus } from "utilities/invitations"
import { asDate } from "utilities/strings"

type Props = {
  recipient: EmailReportRecipient
  eventId: string
}

const EmailReportRow = ({ recipient, eventId }: Props) => {
  const location = useLocation()
  const {
    id,
    guest: { id: guestId, firstName, lastName },
    data: { bounced },
    transactionDate,
    clicks,
    opens,
    softBounced,
    hardBounced,
    toEmail,
  } = recipient

  const guestName = `${firstName} ${lastName}`
  const color = getColorByInvitationStatus({
    clicks, opens, softBounced, hardBounced, bounced,
  })

  return (
    <Tr key={id}>
      <Td>
        <Link
          to={{ pathname: `${eventPath(eventId)}/guests/${guestId}`, state: { background: location } }}
          color="inherit"
          _hover={{ textDecoration: "none" }}
        >
          <Flex alignItems="center" gap={2}>
            <Avatar size="sm" bg={color} name={guestName} />{guestName}
          </Flex>
        </Link>
      </Td>
      <Td>{toEmail}</Td>
      <Td>{asDate(transactionDate)}</Td>
      <Td textAlign="center">{opens || 0}</Td>
      <Td textAlign="center">{clicks}</Td>
      <Td textAlign="center">{softBounced && <Icon icon="checkmark" />}</Td>
      <Td textAlign="center">{hardBounced && <Icon icon="checkmark" />}</Td>
      <Td textAlign="center">{bounced && <Icon icon="checkmark" />}</Td>
    </Tr>
  )
}

export default EmailReportRow
